import { KeyboardSensor, PointerSensor, useSensor, useSensors } from "@dnd-kit/core";

/**
 * Sensors shared by every board (the reusable DataBoard and the projects
 * swimlane board). Pointer drags require 8px of movement so a plain click still
 * reaches the card's own onClick instead of being swallowed as a no-op drag;
 * the keyboard sensor makes drag-and-drop operable without a pointer (WCAG).
 */
export function useBoardSensors() {
  return useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 8 } }),
    useSensor(KeyboardSensor),
  );
}

/**
 * dnd-kit injects `role="button"` into a draggable's attributes. Board cards are
 * already interactive (a button or click target), so spreading that role nests
 * interactive roles — invalid ARIA / WCAG 4.1.2. Strip `role` while keeping the
 * rest (tabIndex, aria-describedby, …). Both the sortable (DataBoard) and the
 * draggable (projects) card wrappers route through this so the fix lives once.
 */
export function withoutDragRole<T extends { role?: string | undefined }>(
  attributes: T,
): Omit<T, "role"> {
  const { role: _role, ...rest } = attributes;
  return rest;
}
